import { render, staticRenderFns } from "./piaozuoxiayoushang.vue?vue&type=template&id=acb22aae&scoped=true&"
import script from "./piaozuoxiayoushang.vue?vue&type=script&lang=js&"
export * from "./piaozuoxiayoushang.vue?vue&type=script&lang=js&"
import style0 from "./piaozuoxiayoushang.vue?vue&type=style&index=0&id=acb22aae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb22aae",
  null
  
)

export default component.exports